/* eslint-disable */
import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class SiteHeaderController extends Controller {

  connect() {
    if (document.body.classList.contains('has-sticky-header')) {
      this.lastScrollTop = 0;
      this.searchTags = document.querySelector('.ez-search-tags');

      window.addEventListener('scroll', this.setStickyHeader);
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.setStickyHeader);
  }

  headerLogin() {
    triggerCustomEvent(events.site_header.header_login, {});
  }

  headerSignUp() {
    triggerCustomEvent(events.site_header.header_signup, {});
  }

  sendHeaderJoinProEvent() {
    triggerCustomEvent(events.site_header.header_join_pro, {});
  }

  setStickyHeader = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop === 0) {
      this.element.classList.remove('is-stuck');
    } else {
      if (!this.element.classList.contains('is-stuck')) {
        this.element.classList.add('is-stuck');
      }
    }

    if (this.searchTags) {
      if (scrollTop > this.lastScrollTop) {
        this.searchTags.classList.remove('scrollUp');
      } else {
        this.searchTags.classList.add('scrollUp');
      }

      this.lastScrollTop = scrollTop;
    }
  }
}
